import {
  FraudJourneyApplicationStatusKYCResponse,
  FraudJourneyApplicationStatusResponse,
  JourneyApplicationStatus,
} from '@ads-bread/shared/bread/codecs';
import { APIFetch } from '../hooks/apiFetch';
import { poll } from '../poll';
import { HandlerResponse, handleResponse } from './base';

export const FRAUD_ALLOY_JOURNEY_STATUS_URI =
  '/api/fraud/alloy/journey-application-status';

export const FRAUD_ALLOY_JOURNEY_STATUS_KYC_URI =
  '/api/kyc/alloy/journey-application-status';

export const getFraudAlloyJourneyStatus = async (
  applicationID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<FraudJourneyApplicationStatusResponse>> => {
  const response = await apiFetch<FraudJourneyApplicationStatusResponse>(
    `${FRAUD_ALLOY_JOURNEY_STATUS_URI}/${applicationID}`,
    { method: 'GET' },
    FraudJourneyApplicationStatusResponse
  );
  return handleResponse(response);
};

export const getFraudAlloyJourneyStatusKYC = async (
  applicationID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<FraudJourneyApplicationStatusKYCResponse>> => {
  const response = await apiFetch<FraudJourneyApplicationStatusKYCResponse>(
    `${FRAUD_ALLOY_JOURNEY_STATUS_KYC_URI}/${applicationID}`,
    { method: 'GET' },
    FraudJourneyApplicationStatusKYCResponse
  );
  return handleResponse(response);
};

/**
 * Polls the Fraud Alloy journey status until it reaches a terminal state
 * @param applicationID
 * @param apiFetch
 * @returns FraudJourneyApplicationStatusResponse
 */
export const pollFraudAlloyJourneyStatus = async (
  applicationID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<FraudJourneyApplicationStatusResponse>> => {
  const fraudAlloyJourneyStatusRes = await poll<
    HandlerResponse<FraudJourneyApplicationStatusResponse>
  >(
    async () => await getFraudAlloyJourneyStatus(applicationID, apiFetch),
    (response) => {
      return (
        !!response.error ||
        response.result.journeyApplicationStatus ===
          JourneyApplicationStatus.Approved ||
        response.result.journeyApplicationStatus ===
          JourneyApplicationStatus.Denied ||
        response.result.journeyApplicationStatus ===
          JourneyApplicationStatus.Error ||
        response.result.journeyApplicationStatus ===
          JourneyApplicationStatus.Expired
      );
    },
    1000,
    10
  );

  return fraudAlloyJourneyStatusRes;
};

/**
 * Polls the Fraud Alloy KYC journey status until it reaches a terminal state
 * @param applicationID
 * @param apiFetch
 * @returns FraudJourneyApplicationStatusKYCResponse
 */
export const pollFraudAlloyJourneyStatusKYC = async (
  applicationID: string,
  apiFetch: APIFetch
): Promise<HandlerResponse<FraudJourneyApplicationStatusKYCResponse>> => {
  const fraudAlloyJourneyStatusRes = await poll<
    HandlerResponse<FraudJourneyApplicationStatusKYCResponse>
  >(
    async () => await getFraudAlloyJourneyStatusKYC(applicationID, apiFetch),
    (response) => {
      return (
        !!response.error ||
        response.result.journey_application_status ===
          JourneyApplicationStatus.Approved ||
        response.result.journey_application_status ===
          JourneyApplicationStatus.Denied ||
        response.result.journey_application_status ===
          JourneyApplicationStatus.Error ||
        response.result.journey_application_status ===
          JourneyApplicationStatus.Expired
      );
    },
    1000,
    10
  );

  return fraudAlloyJourneyStatusRes;
};
